export default "__VITE_ASSET__BXtN96MA__"